/**
 * Display Bridge: Split unified challenge.picks for UI consumption.
 * UI components expect 1X2 (Main section) and other markets (OtherMarkets list) separately.
 *
 * Use:
 * - matchWinnerPicks for Main/1X2 section
 * - otherPicks for OtherMarkets list (BTTS, O/U, etc.)
 */

import type { ChallengePick } from '../../../types/challenges';
import { MATCH_WINNER_MARKET_ID } from '../constants/challenges.constants';

export interface SplitPicksForDisplay {
  /** 1X2 pick (marketId 1) for Main section. One per match. */
  matchWinnerPicks: ChallengePick[];
  /** Other-market picks (BTTS, O/U, etc.) for OtherMarkets list. */
  otherPicks: ChallengePick[];
}

/**
 * Split challenge picks for display (Display Bridge).
 * Filters 1x2 into matchWinnerPicks, rest into otherPicks.
 * Normalizes marketId so API string "1" matches MATCH_WINNER_MARKET_ID.
 */
export function splitChallengePicksForDisplay(
  picks: ChallengePick[] | undefined
): SplitPicksForDisplay {
  const list = picks ?? [];
  return {
    matchWinnerPicks: list.filter((p) => Number(p.marketId) === MATCH_WINNER_MARKET_ID),
    otherPicks: list.filter((p) => Number(p.marketId) !== MATCH_WINNER_MARKET_ID),
  };
}
